import {
  Box,
  HtmlButtonProps,
  IconButton,
  IconNames,
  Tooltip,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PureComponent, ReactNode } from 'react';

import styles from './topbarButton.module.scss';

type TopbarButtonProps = {
  className?: string;
  icon: IconNames;
  showSpinner?: boolean;
  tooltip?: ReactNode;
  showNotificationIndicator?: boolean;
  notificationIndicatorTooltip?: string;
  notificationIndicatorClassName?: string;
} & HtmlButtonProps;

export class TopbarButton extends PureComponent<TopbarButtonProps> {
  render() {
    const {
      className,
      showSpinner,
      icon,
      tooltip,
      showNotificationIndicator,
      notificationIndicatorTooltip,
      notificationIndicatorClassName,
      ...otherProps
    } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: styles.root,
      },
      className,
    );

    const notificationIndicator = classnames(
      {
        [styles.notificationIndicator]: styles.notificationIndicator,
      },
      notificationIndicatorClassName,
    );

    return (
      <Tooltip disabled={!tooltip} content={tooltip} wrap="div">
        <Box className={styles.notificationWrapper}>
          <IconButton
            isLoading={showSpinner}
            icon={icon}
            variant="secondary"
            {...otherProps}
            className={rootClass}
          />
          {showNotificationIndicator && (
            <Tooltip
              disabled={!notificationIndicatorTooltip}
              content={notificationIndicatorTooltip}
            >
              {showNotificationIndicator && (
                <div className={notificationIndicator} />
              )}
            </Tooltip>
          )}
        </Box>
      </Tooltip>
    );
  }
}
